"use strict";

/* Controllers */

_BannerFlowApp.controller(
    "DuplicateDialogController",
    function DuplicateDialogController($scope, $rootScope, AuthInfo, Utils, Notification, Feed) {
        var selectedBrand = angular.copy(AuthInfo.LoggedInUser.currentBrand);

        $scope.duplicateModel = {
            item: angular.copy($scope.ngDialogData.item),
            type: $scope.ngDialogData.type || $rootScope.OBJECT_TYPE_FEED,
            selectedBrand: selectedBrand,
            selectedFolder: angular.copy($scope.ngDialogData.folderId),
            keepVersions: false,
            loading: false,
            preSelectedFormat: $scope.ngDialogData.bannerFormat,
            originalTranslationBool: true
        };
        $scope.$watch("duplicateModel.selectedBrand", function (n, o) {
            if (n === o) return;
            $scope.duplicateModel.selectedFolder = null;
        });

        $scope.checkSizeSelection = function () {
            if ($scope.duplicateModel.type === 0) return true;

            if (
                $scope.duplicateModel.item.regularFormats ||
                $scope.duplicateModel.item.advancedFormats
            ) {
                var anySizeSelected = false;
                $scope.duplicateModel.item.regularFormats.forEach(function (f) {
                    if (f.selected) anySizeSelected = true;
                });
                if (!anySizeSelected) {
                    $scope.duplicateModel.item.advancedFormats.forEach(function (f) {
                        if (f.selected) anySizeSelected = true;
                    });
                }

                return anySizeSelected;
            }
            return true;
        };

        $scope.duplicate = function () {
            $scope.duplicateModel.loading = true;

            var folderId = $scope.duplicateModel.selectedFolder || null;

            var data = {};

            if ($scope.duplicateModel.type === $rootScope.OBJECT_TYPE_FEED) {
                data.id = $scope.duplicateModel.item.id;
                data.folder = folderId;
                data.brandId = $scope.duplicateModel.selectedBrand.id;
            }

            var resource = {};

            if ($scope.duplicateModel.type === $rootScope.OBJECT_TYPE_FEED) {
                resource = Feed;

                data.targetBrandId = data.brandId;
                data.targetFolderId = data.folder;
            }

            var getUrl = "";

            if ($scope.duplicateModel.type === $rootScope.OBJECT_TYPE_FEED) {
                getUrl = "Feeds";
            }

            resource.duplicate(
                data,
                function (newItem) {
                    $scope.duplicateModel.loading = false;
                    $scope.duplicateModel.success = true;

                    var brand = _.find(AuthInfo.LoggedInUser.currentAccount.brands, function (b) {
                        return b.id === newItem.brandId;
                    });

                    $scope.duplicateModel.newItem = newItem;
                    $scope.duplicateModel.newItem.brand = brand;

                    if (brand)
                        $scope.duplicateModel.newItem.url = "/{0}/{1}/{2}/c/{3}".format(
                            AuthInfo.LoggedInUser.currentAccount.slug,
                            brand.slug,
                            getUrl,
                            newItem.id
                        );
                },
                function (error) {
                    $scope.duplicateModel.loading = false;
                    $scope.duplicateModel.success = false;
                    $scope.closeThisDialog();

                    if (error) {
                        var errorMsg = "Could not duplicate successfully";

                        if (error.message) {
                            errorMsg = error.message;
                        }

                        Notification.Show(errorMsg, 6000, "error");
                    }
                }
            );
        };

        $scope.gotoNewItem = function () {
            window.location = $scope.duplicateModel.newItem.url;
        };

        if ($scope.ngDialogData.autoStart) $scope.duplicate();

        $scope.duplicateModel.typeName = Utils.GetObjectTypeName($scope.duplicateModel.type);
    }
);
